import _extends from "@babel/runtime/helpers/extends";
import React, { lazy } from "react";

// Stores components
var StoresBoxText = lazy(() => import("./Stores/boxText"));
var StoresBoxImageMiddle = lazy(() => import("./Stores/boxImageMiddle"));
var StoresSlider = lazy(() => import("./Stores/sliderStores"));
var StoresTopCarousel = lazy(() => import("./Stores/topCarousel"));
var StoresBannerHeader = lazy(() => import("./Stores/bannerHeader"));
var AllStoresCarousel = lazy(() => import("./Stores/allStoresCarousel"));

// Product detail components
var ProductPageBannerTop = lazy(() => import("./ProductDetail/productPageBannerTop"));
var ProductPageSiAbbinaConTutto = lazy(() => import("./ProductDetail/ProductPageSiAbbinaConTutto"));
var ProductPageBannerMiddle = lazy(() => import("./ProductDetail/productPageBannerMiddle"));
var ProductPageBannerMiddle2 = lazy(() => import("./ProductDetail/ProductPageBannerMiddle2"));
var ProductPageBannerMiddle3 = lazy(() => import("./ProductDetail/productPageBannerMiddle3"));

// Homepage components
var Presignature = lazy(() => import("./Homepage/presignature"));
var HomepageBannerMiddle = lazy(() => import("./Homepage/bannerMiddle"));
var HomepageBannerMiddleSingleImage = lazy(() => import("./Homepage/bannerMiddleSingleImage"));
var HomepageBannerImageMiddle = lazy(() => import("./Homepage/bannerImageMiddle"));
var HomepageCarbs = lazy(() => import("./Homepage/carbs"));
var HomepageSliderFull = lazy(() => import("./Homepage/sliderTop"));

// Product takeaway components
var ProductPageInfoExtra = lazy(() => import("./ProductTakeaway/ProductPageInfoExtra"));

// Product page CMS components
var ProductPageCMSImagePlusCTA = lazy(() => import("./ProductPageCMSImagePlusCTA/productPageCMSImagePlusCTA"));

// This is the component that renders widgets
/**
 *
 * @param {{
 *  metadata_json:string,
 *  widget_type:string,
 *  category: any,
 *  hideCategory?: boolean
 * }} props
 * @returns {React.ReactNode}
 */
export default function Widget(_ref) {
  var {
    metadata_json,
    widget_type,
    category,
    hideCategory
  } = _ref;
  var Component = null;
  switch (widget_type) {
    case "Reply\\Store\\Block\\Widget\\RistorantiBoxTitoloTestoCTATop":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBoxTitoloTestoCTAMiddle":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBannerTestoImmagineSfondo":
      Component = StoresBoxImageMiddle;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiBoxTitoloTestoCTABottom":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiCarouselMiddle":
      Component = StoresSlider;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiCarouselTop":
      Component = StoresTopCarousel;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageBannerTopImgTitle":
      Component = StoresBannerHeader;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageBoxTitoloTestoCTATop":
      Component = StoresBoxText;
      break;
    case "Reply\\Store\\Block\\Widget\\RistorantiPageCarousel":
      Component = AllStoresCarousel;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerTop":
      Component = ProductPageBannerTop;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageInfoExtraSiAbbinaConTutto":
      Component = ProductPageSiAbbinaConTutto;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerMiddleTopBottomImage":
      Component = ProductPageBannerMiddle2;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerMiddle2TopImage":
      Component = ProductPageBannerMiddle;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageBannerMiddle3LeftRightImageText":
      Component = ProductPageBannerMiddle3;
      break;
    case "Reply\\Homepage\\Block\\Widget\\Presignature":
      Component = Presignature;
      break;
    case "Reply\\Homepage\\Block\\Widget\\CucinaTuDoppia":
      Component = HomepageBannerMiddle;
      break;
    case "Reply\\Homepage\\Block\\Widget\\CucinaTuSingola":
      Component = HomepageBannerMiddleSingleImage;
      break;
    case "Reply\\Homepage\\Block\\Widget\\BannerImageMiddle":
      Component = HomepageBannerImageMiddle;
      break;
    case "Reply\\Homepage\\Block\\Widget\\Carbs":
      Component = HomepageCarbs;
      break;
    case "Reply\\Homepage\\Block\\Widget\\HomeTopCarousel":
      Component = HomepageSliderFull;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageInfoExtra":
      Component = ProductPageInfoExtra;
      break;
    case "Reply\\Widgets\\Block\\Widget\\ProductPageCMSImagePlusCTA":
      Component = ProductPageCMSImagePlusCTA;
      break;
    default:
      return null;
  }
  var metadata = JSON.parse(metadata_json);

  // Pass the parsed JSON as props to the right component
  return /*#__PURE__*/React.createElement(Component, _extends({
    category: category
  }, metadata, {
    hideCategory
  }));
}